import { lazyLoad } from 'utils/loadable';

export const Reviews = lazyLoad(() => import('./index'));
